import { createSlice } from '@reduxjs/toolkit';

// Aclaración: los paquerypoints de este reducer NO son los de redux/paquerypoint.
// Acá vienen todos, sin discriminar operación logística; el reducer de
// paquerypoint trae únicamente los del OPL logueado.
export const initialState = {
  paquerypointsLoaded: true,
  paquerypoints: [],
  items: [],
  search: '',
  pageable: {
    pageNumber: 0,
    pageSize: 10,
  },
  loaded: false,
};

const packagePpointDepartureSlice = createSlice({
  name: 'packagePpointDeparture',
  initialState,
  reducers: {
    // El listado es local (memoria + localStorage), no hay fetch: apenas se monta
    // la pantalla ya está listo para mostrarse.
    initial: (state) => {
      state.loaded = true;
    },
    success: (state, action) => {
      state.loaded = true;
      state.items = action.payload;
    },
    failure: (state) => {
      state.loaded = true;
    },
    dispatchPackages: (state) => {
      state.loaded = false;
    },
    dispatchPackagesSuccess: (state) => {
      state.loaded = true;
    },
    removePacketSuccess: (state, action) => {
      state.items = state.items.filter((item) => item.id !== action.payload);
    },
    updatePackets: (state, action) => {
      state.items = action.payload;
    },
    addPackage: (state, action) => {
      state.items.unshift(action.payload);
    },
    updatePageable: (state, action) => {
      state.pageable.pageNumber =
        action.payload.pageSize !== state.pageable.pageSize
          ? 0
          : action.payload.pageNumber;
      state.pageable.pageSize = action.payload.pageSize;
    },
    updateSearch: (state, action) => {
      state.pageable.pageNumber = 0;
      state.search = action.payload;
    },
    resetFilters: (state) => {
      state.search = initialState.search;
      state.pageable = initialState.pageable;
    },
    reset: (state) => {
      state.items = initialState.items;
    },
    fetchPaquerypoints: (state) => {
      state.paquerypointsLoaded = false;
    },
    fetchPaquerypointsSuccess: (state, action) => {
      state.paquerypoints = action.payload;
      state.paquerypointsLoaded = true;
    },
    fetchPaquerypointsFailure: (state) => {
      state.paquerypointsLoaded = false;
    },
  },
});

export const { name, reducer, actions } = packagePpointDepartureSlice;
